// extracted by mini-css-extract-plugin
module.exports = {"root":"TextOverHeadline__root--O0VJR","bounce":"TextOverHeadline__bounce--3g-H0"};